module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding@3x-0700ebbde74cd9cd5cf36a97c187f44c.webp";